import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import SearchIcon from '../assets/StatCarr/Progress 1.svg';
import TachometerIcon from '../assets/StatCarr/Progress 2.svg';
import PuzzleIcon from '../assets/StatCarr/Progress 4.svg';
import DiagnosticoImage from '../assets/StatCarr/diagnostico.webp';
import OptimizacionImage from '../assets/StatCarr/optimizacion.webp';
import ImplementacionImage from '../assets/StatCarr/implementacion.webp';

const STEP_ASSETS = [
  { icon: SearchIcon, image: DiagnosticoImage },
  { icon: TachometerIcon, image: OptimizacionImage },
  { icon: PuzzleIcon, image: ImplementacionImage },
];

const StatsSection = () => {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(1);
  const [imageLoading, setImageLoading] = useState({});
  const totalSteps = 3;

  const wizardData = t('statsSection.steps', { returnObjects: true }).map((step, idx) => ({
    ...step,
    id: idx + 1,
    icon: STEP_ASSETS[idx].icon,
    image: STEP_ASSETS[idx].image,
  }));

  const stepsLabels = t('statsSection.steps_labels', { returnObjects: true });

  const steps = stepsLabels.map((label, idx) => ({ id: idx + 1, label }));

  const currentData = wizardData.find(item => item.id === currentStep);

  const nextStep = () => {
    if (currentStep < totalSteps) setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  const goToStep = (stepId) => {
    if (stepId <= totalSteps) setCurrentStep(stepId);
  };

  const finishWizard = () => {
    const contactSection = document.getElementById('contacto');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleImageLoad = (imageId) => {
    setImageLoading(prev => ({ ...prev, [imageId]: false }));
  };

  const handleImageError = (imageId) => {
    setImageLoading(prev => ({ ...prev, [imageId]: false }));
  };

  const handleImageStart = (imageId) => {
    setImageLoading(prev => ({ ...prev, [imageId]: true }));
  };

  useEffect(() => {
    setImageLoading(prev => ({ ...prev, [currentStep]: true }));
  }, [currentStep]);

  return (
    <section className="bg-white flex flex-col" id="como-funciona">
      <div className="divider-conteiner text-center space-y-0 mb:space-y-2">
        <h1 className="font-sans text-secondary font-bold resp-h3">
          {t('statsSection.title')}
        </h1>
        <p className="hero-p resp-h2" style={{ lineHeight: "130%" }}>
          {t('statsSection.subtitle')}
        </p>
      </div>

      <div className="wizard-container">
        <div className="progress-sidebar">
          <div className="progress-steps">
            {steps.map((step) => (
              <div
                key={step.id}
                className={`progress-step ${currentStep === step.id ? 'active' : ''}`}
                onClick={() => goToStep(step.id)}
              >
                <div className="step-number">{step.id}</div>
                <div className="step-label">{step.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="wizard-content">
          <div className={`wizard-panel ${currentStep === currentData.id ? 'active' : ''}`}>
            <div className="panel-header">
              <div className="panel-icon-simple">
                <img src={currentData.icon} alt={`Icono ${currentData.title}`} className="w-20 h-20" />
              </div>
              <div className="panel-title">
                <h2>{currentData.title}</h2>
                <p>{currentData.subtitle}</p>
              </div>
            </div>

            <div className="panel-body">
              <div className="panel-image">
                <img
                  src={currentData.image}
                  alt={currentData.title}
                  className={`${imageLoading[currentData.id] ? 'loading' : 'loaded'}`}
                  onLoad={() => handleImageLoad(currentData.id)}
                  onError={() => handleImageError(currentData.id)}
                  onLoadStart={() => handleImageStart(currentData.id)}
                />
              </div>

              <div className="text-box">
                {currentData.keyPoints.map((point, index) => (
                  <div key={index} className="text-point">
                    <h3>{point.title}</h3>
                    <p>{point.description}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="wizard-navigation">
              <div className="step-indicator">
                {t('statsSection.step_indicator', { current: currentStep, total: totalSteps })}
              </div>
              <div className="nav-buttons">
                {currentStep > 1 && (
                  <button className="nav-button button-prev font-poppins font-bold" onClick={prevStep}>
                    <FaArrowLeft className="mr-2" />
                    {t('statsSection.prev')}
                  </button>
                )}
                {currentStep < totalSteps ? (
                  <button className="nav-button button-next font-poppins font-bold" onClick={nextStep}>
                    {t('statsSection.next')}
                    <FaArrowRight className="ml-2" />
                  </button>
                ) : (
                  <button className="nav-button button-finish font-poppins font-bold" onClick={finishWizard}>
                    {t('statsSection.contact')}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
